angular.module('impactx.search').controller('CountrySearchFilterCtrl', [
    'AppConfiguration',
    'SearchFilter',
    CountrySearchFilterController
]);

function CountrySearchFilterController(AppConfiguration, SearchFilter) {
    var self = this;

    self.$onInit = function () {
        self.showCountryFilter = AppConfiguration.get('showCountryFilter');
        var filters = SearchFilter.getFilters();
        if (filters.then) {
            filters.then(function (result) {
                self.filters = result;
            });
        }
        else {
            self.filters = filters;
        }
    }
}